var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4",staticStyle:{"position":"relative"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('span',{staticClass:"main-title"},[_vm._v("SUMMARY |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Customer report")])]),_c('v-flex',{staticStyle:{"display":"flex","align-items":"center","justify-content":"flex-end"},attrs:{"xs12":"","sm6":""}},[_c('download-excel',{attrs:{"data":_vm.export_customer_report_list,"fields":{
            No: 'no',
            'Customer name': 'user_full_name',
            'Tel.': 'user_tel',
            'Earn point': 'user_point',
            'Food/Free/Mes': 'user_order_count',
          },"name":'CustomerReport_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.xls'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls ")],1)],1),_c('download-excel',{attrs:{"type":"csv","data":_vm.export_customer_report_list,"fields":{
            No: 'no',
            'Customer name': 'user_full_name',
            'Tel.': 'user_tel',
            'Earn point': 'user_point',
            'Food/Free/Mes': 'user_order_count',
          },"name":'CustomerReport_' +
              _vm.search_config.datetime_start +
              '_to_' +
              _vm.search_config.datetime_end +
              '.csv'}},[_c('v-btn',{attrs:{"flat":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv ")],1)],1)],1)],1)],1),_c('searchDateStartToEnd',{attrs:{"searching":_vm.searching,"action_method":"fetchCustomerReport"},on:{"search":function($event){return _vm.searchList()}}}),_c('customerReportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }